module.exports = __webpack_public_path__ + "static/media/animationmanager.a35a17ed.md";